import { Injectable } from '@angular/core';

import { MessageService } from 'primeng/api';
import { listenToErrorState } from '../store/features/request-status.utils';
import { BaseStore } from '../store/features/request-status.feature';
import { isApiError } from './http-gateway.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  public ttl = 3000;

  constructor(private messageService: MessageService) {}

  public sendToast(
    severity: 'success' | 'info' | 'warn' | 'error' | 'secondary' | 'contrast',
    title: string,
    description: string,
    life: number | undefined,
  ) {
    this.messageService.add({
      severity,
      summary: title,
      detail: description,
      life,
    });
  }

  public infoToast(title: string, description: string) {
    this.sendToast('info', title, description, this.ttl);
  }

  public successToast(title: string, description: string) {
    this.sendToast('success', title, description, this.ttl);
  }

  public errorToast(title: string, description: string) {
    this.sendToast('error', title, description, undefined);
  }

  public warnToast(title: string, description: string) {
    this.sendToast('warn', title, description, this.ttl);
  }

  public storeActionToast<A extends string>(
    store: BaseStore<A>,
    action: A,
    success:
      | {
          title: string;
          description: string;
        }
      | undefined,
    error:
      | {
          title: string;
          description: string;
        }
      | undefined,
  ) {
    const errObj = store.getError(action);
    if (errObj) {
      let correlationId: string | undefined = undefined;
      if (isApiError(errObj)) {
        correlationId = errObj?.correlationId;
      }
      if (error)
        this.errorToast(
          error.title,
          correlationId
            ? `${error.description}\n(Correlation ID: ${correlationId})`
            : error.description,
        );
    } else if (store.getSuccess(action)) {
      if (success) this.successToast(success.title, success.description);
    }
  }

  public handleErrorToasts<A extends string>(
    store: BaseStore<A>,
    actions: A[],
  ): void {
    listenToErrorState(store, actions, (action) => {
      this.storeActionToast(store, action, undefined, {
        title: 'Something went wrong',
        description: 'Contact your administrator.',
      });
    });
  }
}
